import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomReactSelect from '@components/CustomReactSelect';
import ModalContainer from '@components/modals/ModalContainer';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchEnumValues, fetchFabricSubCategory, fetchFiberFabricList } from '@services/commonService';
import { onUpdateProductTag } from '@services/supplierService';

import { validateNumber } from '@utils/Util';

const AddFabricParameter = ({
	parameterType,
	onClose,
	onSuccess,
	constructionList = [],
	fiberList = [],
	colorTypeList = []
}) => {
	const [productCategories, setProductCategories] = useState([]);
	const [fibers, setFibers] = useState([]);
	const [colorType, setColorType] = useState([]);
	const [selectedItem, setSelectedItem] = useState({
		constructionIdList: constructionList,
		fiberIdList: fiberList,
		colorTypeList: colorTypeList
	});
	const { id } = useParams();
	const dispatch = useDispatch();
	const isLoading = useSelector((store) => store.loaderStore);

	useEffect(() => {
		dispatch(openLoader());
		fetchFabricSubCategory().then((res) => {
			let tmpCategories = res.map((item) => ({ value: item.id, label: item.name }));
			setProductCategories(tmpCategories);
		});
		fetchFiberFabricList().then((res) => {
			let tmpCategories = res.map((item) => ({ value: item.id, label: item.name }));
			setFibers(tmpCategories);
		});
		fetchEnumValues('info.nitex.app.color.ColorType', setColorType).finally(() =>
			dispatch(closeLoader())
		);
	}, []);

	const onSave = async () => {
		try {
			// if (categories.length === 0) return;
			dispatch(openLoader());
			const response = await onUpdateProductTag(id, {
				supplierType: parameterType,
				constructionIdList: selectedItem?.constructionIdList?.map((item) => item?.value),
				fiberIdList: selectedItem?.fiberIdList?.map((item) => item?.value),
				colorTypeList: selectedItem?.colorTypeList?.map((item) => item?.value),
				maxGsm: selectedItem?.maxGsm,
				minGsm: selectedItem?.minGsm
			});
			if (response) {
				onSuccess();
				onClose();
			}
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const onSelectItem = (type, value) => {
		setSelectedItem({
			...selectedItem,
			[type]: value
		});
	};

	return (
		<ModalContainer>
			<div className="common-popup filter-quick-search-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Add fabric parameter</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12">
							<div className="select-component chip-component mb-3 show">
								<label htmlFor="collection">Select Product Category</label>
								<CustomReactSelect
									selectedValue={selectedItem?.constructionIdList}
									allItems={productCategories}
									onSetSelectedItem={(value) => onSelectItem('constructionIdList', value)}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="select-component chip-component mb-3 show">
								<label htmlFor="collection">Select Fiber</label>
								<CustomReactSelect
									selectedValue={selectedItem?.fiberIdList}
									allItems={fibers}
									onSetSelectedItem={(value) => onSelectItem('fiberIdList', value)}
								/>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Weight range</label>
									<input
										type="number"
										value={selectedItem?.minGsm}
										placeholder="Min gsm"
										onKeyDown={validateNumber}
										onChange={(e) => onSelectItem('minGsm', e.target.value)}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection" className="invisible">
										.
									</label>
									<input
										type="number"
										placeholder="Max gsm"
										value={selectedItem?.maxGsm}
										onKeyDown={validateNumber}
										onChange={(e) => onSelectItem('maxGsm', e.target.value)}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="select-component chip-component mb-3 show">
								<label htmlFor="collection">Color type</label>
								<CustomReactSelect
									selectedValue={selectedItem?.colorTypeList}
									allItems={colorType}
									onSetSelectedItem={(value) => onSelectItem('colorTypeList', value)}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button disabled={isLoading} className="button size32 ml-2" onClick={onSave}>
							Add
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddFabricParameter;
